export const Themecolors = {
  // Main Backgrounds
  main_bg1: "var(--matx-palette-primary-main)", // Deep blue for primary background
  main_bg2: "var(--matx-palette-secondary-main)", // Vibrant orange for secondary background
  theme_Main: "#6b73ac", // theme color fro entire

  // Buttons
  Button1: "var(--matx-palette-secondary-main)", // Primary button background (orange)
  Button2: "var(--matx-palette-primary-main)", // Secondary button text (blue)
  Button3: "#1976d2", // Neutral button e0e0e0
  Button_bg1: "var(--matx-palette-secondary-main)", // Orange background
  Button_bg2: "#1976d2", // Blue background
  Button_bg3: "#f5f5f5", // Light gray background
  Button_bg4: "#eceff1", // Very light gray for disabled buttons
  Button_border1: "var(--matx-palette-secondary-main)", // Orange border
  Button_border2: "#1976d2", // Blue border
  button_hover1: "linear-gradient(90deg, #ffd95b 0%, #ffa726 100%)", // Orange hover gradient
  button_hover2: "linear-gradient(90deg, #64b5f6 0%, #1565c0 100%)", // Blue hover gradient
  button_disabled_bg: "#cfd8dc", // Muted gray for disabled buttons
  button_disabled_text: "#9e9e9e", // Disabled button text color

  // Headers
  H_text1: "#1565c0", // Blue for header text
  H_text2: "#ffa726", // Orange for header highlights
  H_text3: "var(--matx-palette-primary-contrastText)", // White text for headers
  H_hv: "linear-gradient(360deg, #ffffff 0%, #e0e0e0 100%)", // Subtle hover effect for headers

  // DataGrid
  Dg_bg1: "#f5f5f5", // Light gray background
  Dg_bg2: "var(--matx-palette-primary-main)", // Professional blue header background
  Dg_Icon_bg3: "#90caf9", // Soft blue for icons
  Dg_text1: "var(--matx-palette-primary-contrastText)", // White text for headers
  Dg_text2: "#90caf9", // Active text color
  Dg_Icon1: "#90caf9", // Icon color
  Dg_Icon2: "var(--matx-palette-primary-main)", // Search icon color

  // Dashboard
  DB_bg: "var(--matx-palette-background-default)", // Light gray for dashboard background
  DB_bg1: "#ffa726", // Dashboard orange highlight
  DB_Icon2: "#1976d2", // Blue for icons in the dashboard
  DB_text2: "#1565c0", // Blue for text
  DB_hv1: "linear-gradient(90deg, #ffd95b 0%, #ffa726 100%)", // Orange hover effect
  DB_hv3: "linear-gradient(90deg, #fafafa 0%, #e0e0e0 100%)", // Subtle ash hover effect

  // Forms and Inputs
  InputText_Color1: "#1976d2", // Blue text for inputs
  InputText_Color2: "var(--matx-palette-text-primary)", // Neutral black text
  InputText_Color3: "#ffa726", // Orange text for inputs
  InputText_Color4: "var(--matx-palette-text-secondary)", // ash for description of from fields
  InputBorder1: "var(--matx-palette-primary-main)", // Blue border for inputs
  InputBorder2: "#ffa726", // Orange border for inputs

  // Upload Button
  UP_Button1: "var(--matx-palette-primary-main)", // Blue for upload button
  UP_Button_Border: "#ffa726", // Orange border for upload button

  // User Header Component
  UH_Icon1: "#ffa726", // Orange for icons
  UH_Icon2: "#1976d2", // Blue for icons
  UH_Icon_bg1: "var(--matx-palette-secondary-main)", // Orange background for icons
  UH_text1: "#ffffff", // White text
  UH_text2: "#ffa726", // Orange text
  UH_text3: "#1565c0", // Blue text
  UH_hv1: "linear-gradient(90deg, #ffb74d 0%, #ffa726 100%)", // Orange hover
  UH_hv2: "linear-gradient(90deg, #64b5f6 0%, #1976d2 100%)", // Blue hover

  // TabBar
  T_bg1: "var(--matx-palette-secondary-main)", // Orange tab background
  T_bg2: "var(--matx-palette-primary-main)", // Blue tab background

  // Form Fields
  F_bg2: "var(--matx-palette-primary-main)", // Blue background for form fields
  F_text1: "#ffffff", // White text for form fields

  // Radio Button
  RB_Selected2: "var(--matx-palette-secondary-main)", // Orange for selected radio button

  // Footer
  footer_bg: "#102027", // Dark blue-gray for footer background
  footer_text: "#b0bec5", // Light gray for footer text

  // Gradients
  B_hv1: "linear-gradient(90deg, #ffb74d 0%, #ffa726 100%)", // Orange button hover
  B_hv2: "linear-gradient(90deg, #64b5f6 0%, #1565c0 100%)", // Blue button hover
  B_hv3: "linear-gradient(90deg, #f5f5f5 0%, #e0e0e0 100%)", // Ash hover
  Error_Color: "#FF0000",
  Success_Color: "#00FF00",
  // Sidenav specific colors
  S_bg1: "#ffffff", // primary sidenav background
  S_bg2: "#ffffff", // secondary sidenav background
  S_text1: "#1f1f1f", // primary text - charcoal
  S_text2: "#4b5563", // secondary text - slate gray
  S_hover: "#f3f4f6", // hover background - soft gray
  S_active: "#e5e7eb", // active/selected state background
  S_border: "#d1d5db", // border accent for focus/active states

  // Note Panel specific colors
  NP_bg_panel: "#fafafa", // very light gray panel background
  NP_bg_user: "#eaf2fd", // light blue for current user's notes
  NP_bg_other: "#ffffff", // white for other notes
  NP_border: "#e0e0e0", // light border around elements
  NP_text: "#333333", // standard text color for notes

  // App bar / menus & iconography
  Menu_bg: "var(--matx-palette-background-paper)", // Topbar/menu background
  Manu_hv1: "linear-gradient(90deg, #ffb74d 0%, #ffa726 100%)", // Hover gradient for menu/icon buttons
  User_Text: "#333333", // Default user/menu text color
  Icons_blue: "#1976d2", // Consistent icon blue
};

export const fonts = {
  roboto: "var(--matx-font-family)",
  poppins: "var(--matx-font-family)",
  lato: "var(--matx-font-family)",
  montserrat: "var(--matx-font-family)",
  open_sans: "var(--matx-font-family)",
  inter: "var(--matx-font-family)",
};
